<script lang="ts" setup>
import type { IBanner } from '~/shared/interfaces/banners';

const banners = ref<IBanner[]>([])

async function getBanners() {
  const type = "brand_horizontal"
  const { data } = await useFetch(`/api/banners/${type}`)
  if(data.value){
    banners.value = data.value
  }
}

await getBanners()
</script>

<template>
  <div v-if="banners.length > 0" class="small-banners">
    <NuxtLink
      class="small-banners__item"
      v-for="banner in banners"
      :to="banner.link"
      :target="banner.target_blank ? '_blank' : '_self'"
    >
      <nuxt-img
        class="small-banners__image small-banners__image_desktop"
        :src="banner.image"
        alt=""
        loading="lazy"
      />
      <nuxt-img
        class="small-banners__image small-banners__image_mobile"
        :src="banner.image"
        alt=""
        loading="lazy"
      />
    </NuxtLink>
  </div>
</template>

<style lang="scss" scoped>
.small-banners {
  display: flex;
  gap: 24px;
  @include md-breakpoint {
    gap: 8px;
  }
  @include sm-breakpoint {
    flex-direction: column;
  }

  &__item {
    width: 100%;
    overflow: hidden;
    border-radius: 16px;
    display: flex;
  }

  &__image {
    width: 100%;

    &_desktop {
      @include md-breakpoint {
        display: none;
      }
    }

    &_mobile {
      display: none;
      @include md-breakpoint {
        display: flex;
      }
    }
  }
}
</style>
